import { Component, type ErrorInfo, type ReactNode } from 'react';
import { ServerErrorPage } from './ServerErrorPage';

export interface ErrorBoundaryProps {
    children: ReactNode;
    fallback?: ReactNode;
    onError?: (error: Error, errorInfo: ErrorInfo) => void;
}

interface ErrorBoundaryState {
    hasError: boolean;
    error: Error | null;
}

/**
 * Arabic ErrorBoundary — catches render errors and shows a 500-style page.
 */
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    state: ErrorBoundaryState = {
        hasError: false,
        error: null,
    };

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.error('[ErrorBoundary]', error, errorInfo);
        this.props.onError?.(error, errorInfo);
    }

    handleRetry = () => {
        this.setState({ hasError: false, error: null });
    };

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }

            return (
                <ServerErrorPage
                    onRetry={this.handleRetry}
                    message="حدث خطأ أثناء عرض الصفحة. يرجى إعادة المحاولة أو العودة للرئيسية."
                />
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
